import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const institutionItemApi = {
    getInstitutionItemById: (id: number): Observable<Dtos.GetInstitutionItemByIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionItemById = new Dtos.GetInstitutionItemById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetInstitutionItemByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionItemsByInstitutionId: (institutionId: number): Observable<Dtos.GetInstitutionItemsByInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionItemsByInstitutionId = new Dtos.GetInstitutionItemsByInstitutionId();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetInstitutionItemsByInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setInstitutionItem: (institutionItem: Dtos.InstitutionItem, _collection: Dtos.Collection): Observable<Dtos.SetInstitutionItemResponse> => {
        let request: Dtos.SetInstitutionItem = new Dtos.SetInstitutionItem();

        request.institutionItem = institutionItem;
        // request.collection = collection;

        // send request
        const response: Promise<Dtos.SetInstitutionItemResponse> = client.post(request);

        return Observable.from(response);

    },
    createInstitutionItem: (institutionId: number): Observable<Dtos.CreateInstitutionItemResponse> => {
        //Create the request.
        let request: Dtos.CreateInstitutionItem = new Dtos.CreateInstitutionItem();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.CreateInstitutionItemResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    }
}